import type { ReactNode } from 'react';
import { segBtnCls } from './styles';

export interface SegOption {
  value: string;
  label?: string;
  icon?: ReactNode;
  title?: string;
}

interface Props {
  options: SegOption[];
  value: string;
  onChange: (v: string) => void;
  label?: string;
}

/**
 * Bordered segmented control (a small set of mutually exclusive options, e.g.
 * List | Board or Leaderboard | Grid). When an option has both an icon and a
 * label, the label collapses on mobile.
 */
export default function SegmentedControl({ options, value, onChange, label }: Props) {
  return (
    <div
      role="group"
      aria-label={label}
      className="inline-flex items-center gap-0.5 rounded-lg border border-gray-300 bg-gray-100 p-0.5 dark:border-gray-600 dark:bg-gray-900/40"
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          aria-pressed={value === o.value}
          title={o.title}
          className={segBtnCls(value === o.value)}
        >
          {o.icon}
          {o.label && <span className={o.icon ? 'hidden sm:inline' : undefined}>{o.label}</span>}
        </button>
      ))}
    </div>
  );
}
